import { isStag } from './isStag';

export const getWebBaseURL = async () => {
  // // 로컬 개발 환경에서는 현재 origin 사용
  // if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  //   return window.location.origin;
  // }

  if (await isStag()) {
    if (document.referrer.length === 0) {
      return 'https://m-stag.a-bly.com';
    }
    const lastChar = document.referrer.charAt(document.referrer.length - 1);
    if (lastChar === '/') {
      return document.referrer.slice(0, -1);
    }
    return document.referrer;
  }
  return 'https://m.a-bly.com';
};
